import { Grid3X3, ShieldCheck, Sparkles } from 'lucide-react';

const markers = [
  { label: 'Portail des applications', value: 'Accès centralisé' },
  { label: 'Direction territoriale', value: 'Secteur Centre' },
  { label: 'Environnement sécurisé', value: 'Accès authentifié' },
];

export default function RadarHud() {
  return (
    <aside className="fixed top-24 bottom-16 left-1/2 z-0 flex w-[260px] -translate-x-1/2 items-center pointer-events-none">
      <section className="relative w-full overflow-hidden rounded-2xl border border-blue-400/20 bg-[#0b1220]/88 px-5 py-6 shadow-[0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-md">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover opacity-55"
        >
          <source src="/fond_video.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-[#07111f]/35 via-[#0b1220]/60 to-[#0b1220]/92" />
        <div className="absolute -top-24 left-1/2 h-48 w-48 -translate-x-1/2 rounded-full bg-blue-500/20 blur-3xl" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-300/70 to-transparent" />

        <div className="relative text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-blue-300/20 bg-blue-400/5 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.12em] text-blue-100">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(74,222,128,0.8)]" />
            Division Paris Centre
          </div>

          <div className="relative -mx-5 my-5 flex h-[252px] w-[calc(100%+40px)] items-center justify-center">
            <div className="absolute inset-x-6 top-1/2 h-24 -translate-y-1/2 rounded-full bg-blue-500/20 blur-2xl" />
            <img src="/logofond.png" alt="Blason de la Police municipale DT Centre" className="relative h-full w-full object-contain drop-shadow-[0_12px_26px_rgba(0,0,0,0.8)]" />
          </div>

          <h2 className="text-sm font-extrabold uppercase tracking-[0.2em] text-white">DT Centre</h2>
          <p className="mt-2 text-[10px] font-medium uppercase tracking-[0.14em] text-slate-400">Proximité · Exemplarité · Probité</p>
        </div>

        <div className="relative my-6 h-px bg-gradient-to-r from-transparent via-blue-300/25 to-transparent" />

        <div className="relative space-y-4">
          {markers.map(({ label, value }, index) => {
            const Icon = index === 0 ? Grid3X3 : index === 1 ? Sparkles : ShieldCheck;
            return (
              <div key={label} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md border border-blue-300/15 bg-blue-400/5 text-blue-200"><Icon size={13} strokeWidth={1.8} /></span>
                <div className="min-w-0">
                  <p className="text-[9px] font-bold uppercase tracking-[0.12em] text-slate-500">{label}</p>
                  <p className="mt-0.5 text-[11px] font-medium text-slate-200">{value}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="relative mt-6 flex items-center justify-center gap-2 border-t border-blue-300/10 pt-4 text-[9px] font-semibold uppercase tracking-[0.16em] text-slate-500">
          <span className="h-1.5 w-1.5 rounded-full bg-blue-400" /> Hub opérationnel
        </div>
      </section>
    </aside>
  );
}
